<script lang="ts" setup>
import type { Meta } from '@/utils/types'

const props = defineProps({
    pagerCount: {
        type: Number,
        default: 5
    },
    layout: {
        type: String,
        default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
        type: Boolean,
        default: false
    },
    autoScroll: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: false
    },
    pageMeta: {
        type: Object as PropType<Meta>,
        default: () => null
    },
    handleChangePage: {
        type: Function,
        default: () => { }
    }
})

const emit = defineEmits(['update:page'])

const currentPage = computed<number | undefined>({
    get: () => props.pageMeta.current_page,
    set: val => {
        emit('update:page', val)
    }
})

function handleCurrentChange(page: number) {
    props.handleChangePage(page)
}
</script>

<template>
    <div :class="{ hidden: hidden }" v-if="pageMeta !== null && pageMeta.per_page <= pageMeta.total">
        <el-pagination class="h-pagination center" :background="background" :page-size="pageMeta.per_page"
            :pager-count="pagerCount" v-model:current-page="currentPage" :layout="layout" :total="pageMeta.total"
            @current-change="handleCurrentChange" />
    </div>
</template>
<style lang="scss" scoped></style>